import React from "react";

export default function BackorderFlag({quantity}) {
  return (quantity <= 0) ? <span style={{color: "#ff991f", padding: "0.3rem", lineHeight: "30px"}}>BACKORDER</span> : null;
}

